/**
 * Injects navigation routes into router.
 *
 * This behavior should be attached at the menu-view level.
 */

import Marionette from "backbone.marionette";
import Radio from "backbone.radio";
import { slugify } from "../utils";

const channel = Radio.channel("global");

class Navigation extends Marionette.Behavior {
  defaults() {
    return {
      category: "unknown",
    };
  }

  // will be called once per menu collection, once for top menu and once for
  // side menu.
  onBeforeRenderCollection() {
    // clone the original collection
    const _coll = this.view.collection.clone();

    // clears the original collection
    this.view.collection.reset([], { silent: true });

    // find deleted, hidden and items that should not appear based on role
    const _deleted = _coll.where({ deleted: true });
    const _hidden = _coll.where({ hidden: true });
    const _invalidRole = _coll.where({ validRole: false });

    // when items need to be deleted
    if (_deleted.length + _hidden.length + _invalidRole.length) {
      // remove those items from cloned collection
      _coll.remove(_deleted);
      _coll.remove(_hidden);
      _coll.remove(_invalidRole);
    }

    // update collection
    _coll.map((model) => {
      // set route name
      model.setName(slugify(model.getPath()));

      // set category
      model.setCategory(this.options.category || this.view.options.section);

      // set route name and parent label in each child item
      const parentLabel = model.getLabel();
      return model.getChildren().map((item) => {
        // set route name
        item.name = slugify(`${item.path}`);

        // set title
        item.title = parentLabel;

        // mark parent route active when necessary
        if (item.defaultRoute) {
          model.setDefaultRoute(true);
        }

        return item;
      });
    });

    // inject current shard name into environment route label
    const environmentRoute = _coll.findWhere({ name: "environment" });
    if (environmentRoute) {
      const shardCount = channel.request("shard:count");
      environmentRoute.set("label", channel.request("shard:name"));
      // reset children when only one shard exists
      if (shardCount < 2) {
        environmentRoute.set("children", []);
      }
    }

    // clean up user profile placeholder
    const profileRoute = _coll.findWhere({ name: "user" });
    if (profileRoute) {
      // reset any children just in case
      profileRoute.set("children", []);
    }

    const updatedCollection = this._overrideActiveRoute(_coll);

    // updates the original collection
    this.view.collection.reset(updatedCollection.toJSON());

    // add these routes to router
    channel.request("router:add", updatedCollection);
  }

  _overrideActiveRoute(_coll) {
    const { route } = this.options;
    if (route) {
      const routeParts = route.split(".");
      if (routeParts.length === 2) {
        // disable current default route
        _coll
          .filter({ defaultRoute: true })
          .map((model) => model.setDefaultRoute(false))
          .map((model) => {
            const _children = model.getChildren();
            _children.forEach((child) => {
              child.defaultRoute = false;
            });
          });

        // enable new default route
        const [category, report] = routeParts;
        const menu = _coll.get(category);
        if (menu) {
          menu
            .setDefaultRoute(true)
            .getChildren()
            .filter((item) => item.name === report)
            .map((child) => {
              child.defaultRoute = true;
            });
        }
        // } else {
        // 	console.warn(new Error(`route, '${route}', could not be parsed`));
      }
    }

    return _coll;
  }
}

export { Navigation as default };
